import * as React from 'react';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ContextStore } from 'bernie-core';
import { inject, observer } from 'mobx-react';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { FindAnswersStore } from 'stores/find-answers-store';
import { AskAQuestion } from 'components/infosite/conversations';
import { AskAQuestionResult } from 'components/infosite/conversations/ask-a-question-result';
import { AskAQuestionData } from 'components/infosite/conversations/ask-a-question';

export interface ShowAskQuestionFormProps extends LocalizedComponentProps {
  context?: ContextStore;
  currentHotel?: CurrentHotelStore;
  findAnswersStore?: FindAnswersStore;
  show?: boolean;
}

export interface ShowAskQuestionFormState {
  showResponse?: boolean;
  errorFetching?: boolean;
}

@withLocalization
@inject('context', 'currentHotel', 'findAnswersStore')
@observer
export class ShowAskQuestionForm extends React.Component<ShowAskQuestionFormProps, ShowAskQuestionFormState> {
  constructor(props) {
    super(props);
    this.state = {
      showResponse: false,
      errorFetching: false
    };

    this.handleCreateQuestion = this.handleCreateQuestion.bind(this);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ showResponse: false });
    }
  }

  public handleCreateQuestion(data: AskAQuestionData): void {
    const { context, currentHotel, findAnswersStore } = this.props;
    const { name, question, email } = data;
    findAnswersStore
      .createQuestion(context, currentHotel.hotelId, email, question, name)
      .catch(() => {
        this.setState({ errorFetching: true });
      })
      .finally(() => {
        this.setState({ showResponse: true });
      });
  }

  public render() {
    const { showResponse, errorFetching } = this.state;
    const { l10n, show } = this.props;

    const newConversation = {
      form: {
        comment: {
          label: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.label'),
          placeholder: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.question.placeholder'),
          invalid: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.question.errorSummary')
        },
        name: {
          label: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.name.placeholder'),
          placeholder: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.name.placeholder'),
          required: false
        },
        emailAddress: {
          label: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.email.placeholder'),
          placeholder: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.email.placeholder'),
          invalid: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.email.invalidEmail.errorSummary')
        },
        actionText: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.button.label'),
        resultText: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.notification')
      },
      title: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.header')
    };

    const askAQuestionProps = {
      ...newConversation,
      loading: false,
      success: true,
      onSubmit: this.handleCreateQuestion,
      alert: '',
      action: ''
    };

    const askAQuestionResultProps = {
      success: !errorFetching,
      message: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.submit.confirmation.subject'),
      action: l10n.formatText('hotels.infosite.findAnswers.askQuestion.form.submit.confirmation.message'),
      linkClickFocusId: 'conversation-comment'
    };

    return (
      <React.Fragment>
        {!showResponse && show && <AskAQuestion {...askAQuestionProps} />}
        {showResponse && <AskAQuestionResult {...askAQuestionResultProps} />}
      </React.Fragment>
    );
  }
}
